import { BaseApiResponse } from '../../api/shared'
import { useContrastMutation } from '../../hooks/use-contrast-mutation'
import { HTTPError } from '../../api/fetch/decorate-fetch'
import { UseMutationOptions } from 'react-query'
import {
  updateVulnerabilityTtrTimeFilterType,
  UpdateVulnerabilityTtrTimeFilterTypeArgs
} from './api/update-vulnerability-ttr-time-filter-type'

export const useUpdateVulnerabilityTtrTimeFilterType = (
  options: UseMutationOptions<
    BaseApiResponse,
    HTTPError,
    UpdateVulnerabilityTtrTimeFilterTypeArgs
  >
) => {
  return useContrastMutation<
    BaseApiResponse,
    HTTPError,
    UpdateVulnerabilityTtrTimeFilterTypeArgs
  >(updateVulnerabilityTtrTimeFilterType, { ...options })
}
